import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IOperon } from 'stores/models/LacOperon';
import GeneExpression from './GeneExpression';

interface IProps {
  model: IOperon;
}

class View extends Component<IProps> {
  render() {
    const { expressibleGenes, info } = this.props.model;
    const genes = expressibleGenes.get();

    return (
      <div className='is-family-code'>
        {info.prefix}
        {genes.map((gene) => (
          <GeneExpression key={gene.info.qualifier} gene={gene} />
        ))}
      </div>
    );
  }
}

const OperonExpression = observer(View);
export default OperonExpression;
